var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsulationBasementCeiling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 21590 27940",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_867700752"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M17684 21226l25 3931 -13281 0 42 -4537 13224 6 -10 600zm-13228 -5784l0 0 13225 0 0 4577 -13225 0c0,-1527 0,-3051 0,-4577zm28 -5279l0 0 13169 0 28 4661 -13225 0 28 -4661zm6571 -8199l0 0c98,26 76,37 147,105l8473 7476 -17213 0 8593 -7581zm-9772 7890l0 0c-17,347 708,309 1151,309 478,0 955,0 1432,0l-63 10557 -1930 1c-254,0 -562,-42 -562,309 0,141 140,280 281,280l2246 0c0,1314 -28,2536 -28,3847l-2162 0c-447,0 -427,590 -56,590l16735 0 0 -5111 1292 0c375,0 319,-589 -28,-589l-1264 0 -56 -9884c277,0 2213,48 2432,-38 197,-78 231,-313 -65,-560l-9197 -8128c-307,-305 -398,-323 -674,-42l-9227 8126c-99,79 -257,168 -257,333z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "4464,21226 17684,21226 17694,20626 4470,20620 ",
    fill: "#FDD625"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsulationBasementCeiling);
export default __webpack_public_path__ + "static/media/insulation-basement-ceiling.e7e375407255488da2d3c102dab103e5.svg";
export { ForwardRef as ReactComponent };